<template>
  <div class="business">
    <top-nav></top-nav>
    <banner  :bgImage="bgImage"></banner>

    <div class="aboutReyzarBox">
      <div class="aboutReyzarTit">
        <div class="aboutReyzarTitTop">主营业务</div>
        <div class="aboutReyzarTitMid" style="letter-spacing: 4px">
          MAIN&nbsp;&nbsp;BUSINESS
        </div>
        <div class="aboutReyzarTitButtom">
          专业高效研发团队&nbsp;&nbsp;致力于提供优质产品和精准定制化方案
        </div>
      </div>
      <div class="businessBox">
        <ul class="clearfix">
          <li v-for="(item,index) in businessArr" :key="'business'+index">
            <div class="businessIn">
              <div class="businessInTit">{{item.title}}</div>
              <div class="businessInConn">
                {{item.content}}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "business",
  data() {
    return {
      bgImage:'../../../static/images/businessBanner.jpg?011801',
      businessArr: [
        {
          title: '6云（6Cloud）产品系列',          
          content: '提供基础设施虚拟化搭建成可配置的计算资源共享池，为公共用户提供弹性的计算、存储、网络、应用和服务等资源效用的平台服务。基于双栈的云平台将同时提供双栈内容发布、负载均衡、聚类分析引擎、内容加速、日志溯源等平台服务。'
        },
        {
          title: 'IPv4-IPv6无缝对接产品系列',          
          content: '帮助现有IPv4网站及业务系统快速升级兼容IPv6和IPv4访问，原IPv4系统无需改造，也可帮助新建IPv6业务系统兼容IPv4访问，加快网络访问速度。本系列通过专利技术有效解决由于外链导致的内容缺失问题，优于国际同类产品和解决方案。'
        },
        {
          title: 'IPv6缓存加速产品系列',          
          content: '实现互联网热点内容缓存和加速，提升用户访问体验，节省网络出口带宽成本。本系列优先使用IPv6获取外网网络资源，充分利用IPv6道路通畅，资费便宜的优点，同时为本地用户提供IPv4和IPv6访问支持。'
        },
        {
          title: 'IPv6内容分发产品系列',          
          content: '帮助IPv4网站和内容源实现广域的内容分发（CDN），可以同时向IPv4和IPv6两个网络平面发布。'
        },
        {
          title: 'IPv6网络支撑系统产品系列',          
          content: '本系列支持多设备堆叠，在无需外部负载均衡设备配合的情况下，实现多设备的负载均衡和冗余备份。'
        },
        {
          title: '基于IPv6的智慧城市系统集成服务',          
          content: '基于IPv6的云平台建设、大数据系统开发，以及电子政务、平安城市等智慧城市的规划和建设服务。'
        },
        {
          title: '支持IPv6的网络优化产品系列',          
          content: '帮助运营商或大型企业监测生产网络或内部办公网络的时延、丢包等各种业务参数，为网络优化和规划提供数据支撑。'
        },
        {
          title: '基于IPv6的地址复用解决方案',          
          content: '通过将后端服务平台私有IPv4或者IPv6地址映射为同一公网IPv4地址，通过不同的域名解析出对应的私有IPv4或者IPv6地址识别目的访问站址，节约政府、企事业单位IPv4公网地址资源。'
        },
        {
          title: '基于IPv6的信息孤岛解决方案',          
          content: '帮助解决私有IPv4信息孤岛数据不能共享、互访的问题，对原有IPv4网络没有任何影响；同时平台支持高可用、负载均衡的方式部署，具备很高的可用性和弹性的横向扩展能力。'
        },
        {
          title: 'IPv4-IPv6应用互通云平台2.0 \n（6aaS-IPv6 as a Service）',          
          content: '该平台采用分布式部署架构，结合云计算、大数据分析等技术，具备云服务、内容分发、IPv6升级等能力，提供更为智能、更为强大的分布式IPv4、IPv6内容加速服务，在全国主要的互联网枢纽部署节点，面向电子政务及公众企业提供IPv6应用升级服务。该平台可以不受地域和运营商的局限，智能感知并快速响应用户的访问需求，真正实现互联互通，彻底解决IPv6应用升级难题。'
        },
        {
          title: 'IPv6技术服务',          
          content: '专业提供IPv6迁移演进的一站式技术服务，包括技术咨询评估、IPv6演进方案规划设计、项目部署实施、系统集成、运行维护以及技术培训等服务。'
        },
      ],
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
.business {
  .aboutReyzarBox {
    width: 1200px;
    height: auto;
    padding: 95px 0;
    margin: 0 auto;
    color: #818181;
    .aboutReyzarTit {
      width: 100%;
      height: auto;
      margin: 0 auto;
      text-align: center;
      .aboutReyzarTitTop {
        width: 100%;
        line-height: 30px;
        text-align: center;
        font-size: 30px;
        letter-spacing: 28px;
        margin-left: 14px;
        margin-bottom: 10px;
      }
      .aboutReyzarTitMid {
        width: 100%;
        line-height: 18px;
        text-align: center;
        text-transform: uppercase;
        font-size: 18px;
        margin-bottom: 20px;
      }
      .aboutReyzarTitButtom {
        width: auto;
        height: 34px;
        line-height: 24px;
        padding-top: 10px;
        font-size: 24px;
        border-top: 1px solid #999a9b;
        display: inline-block;
        margin-bottom: 60px;
      }
    }
  }
  .businessBox {
    width: 100%;
    height: auto;
    li {
      width: 400px;
      height: auto;
      float: left;
      padding-bottom: 60px;
      .businessIn {
        width: 340px;
        height: auto;
        margin: 0 auto;
        .businessInTit {
          width: 100%;
          line-height: 18px;
          font-size: 18px;
          color: #73a9f1;
          padding-left: 15px;
          border-left: 4px solid #73a9f1;
          margin-bottom: 20px;
          text-align: left;
          white-space: pre-wrap;
        }
        .businessInConn {
          width: 100%;
          line-height: 24px;
          color: #818181;
          text-align: justify;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/business/business.vue